// Copy dictionaries — copied verbatim from design_handoff_cfc_redesign/CFC Team Menxhiqi.dc.html
// Do not hand-edit the copy here without updating the design reference too.

export const SQ = {
  navPrograms: "Programet",
  navSchedule: "Orari",
  navHistory: "Historia",
  navContact: "Kontakti",
  navCta: "Provo falas",
  scroll: "Shfleto",
  heroKicker: "Klub kickbox-i · Prishtinë · që nga 1996",
  heroLine1: "Kickbox.",
  heroLine2: "Ashtu si kampionët.",
  heroSub:
    "Trajnime për meshkuj, femra dhe fëmijë nga klubi më i suksesshëm në Kosovë. Kampionë botërorë, 29 vite përvojë, një sallë në Prishtinë — vendi ku trajnohen kampionët e së nesërmes.",
  heroCta: "Rezervo seancën e parë falas",
  heroCta2: "Shiko orarin",
  wc: "Kampion bote",
  since: "që nga",
  s1: "Vite përvojë trajnimi",
  s2: "Kampionë botërorë",
  s3: "Klube në Kosovë & Holandë",
  s4: "Seanca javore",
  progKicker: "Programet & çmimet",
  progTitle: "Një program për çdo nivel.",
  progIntro:
    "Grupe të ndara sipas moshës dhe nivelit. Fillestarët janë të mirëpritur — pajisjet për seancën e parë i ofrojmë ne.",
  progCta: "Regjistrohu",
  perMonth: "/ muaj",
  popular: "Më i kërkuari",
  progNote: "Seanca e parë është falas për çdo program. Nuk ka tarifë regjistrimi.",
  schedKicker: "Orari",
  schedTitle: "Kur trajnojmë.",
  schedGroup: "Grupi",
  schedNote: "Orari mund të ndryshojë gjatë festave dhe garave — ndjek Instagram-in për njoftime.",
  histKicker: "Historia",
  histTitle: "Tridhjetë vjet në ring.",
  histIntro:
    "Team Menxhiqi u themelua nga pionierët e kickbox-it në Kosovë. Klubi është shpallur për vite radhazi klubi më i suksesshëm në vend dhe ka nxjerrë garues të Përfaqësueses së Kosovës për dekada.",
  champTitle: "Kampionë botërorë nga klubi",
  coachKicker: "Trajneri kryesor",
  coachBadge: "Selektor i Kosovës",
  coachTitle: "Ilir Menxhiqi — kampion dhe trajner",
  coachP1:
    "Një nga figurat më të njohura të kickbox-it në Kosovë. Në Kampionatin Botëror 2010 fitoi medaljen e artë si në Thai-Box ashtu edhe në Kick-Box në kategorinë 60 kg, dhe u shpall sportisti më i mirë i Vushtrrisë për atë vit.",
  coachP2:
    "Si trajner udhëheq Përfaqësuesen e Kosovës në kickbox si selektor dhe është shpallur trajneri më i mirë për vitin 2024. Sot trajnon gjeneratën e re në CFC Prishtinë.",
  cf1: "Ar në Botëror 2010 — Thai-Box & Kick-Box",
  cf2: "Sportisti i vitit, Vushtrri",
  cf3: "Trajneri i vitit",
  contactKicker: "Kontakti",
  contactTitle: "Na gjeni në Prishtinë.",
  addrLabel: "Adresa",
  phoneLabel: "Telefon & email",
  formTitle: "Rezervo seancën e parë — falas",
  formSub: "Të kontaktojmë brenda 24 orëve për të caktuar ditën.",
  fName: "Emri",
  fSurname: "Mbiemri",
  fEmail: "Email",
  fProgram: "Programi",
  fMessage: "Mesazhi (opsional)",
  submit: "Dërgo kërkesën",
  submitted: "Kërkesa u dërgua — ju kontaktojmë së shpejti",
  closeTitle: "Seanca e parë është falas. Eja në sallë.",
  closeCta: "Rezervo tani",
  footTag: "Klub kickbox-i në Prishtinë, pjesë e rrjetit Team Menxhiqi që nga 1996.",
  footInfo: "Info",
  footSocial: "Rrjetet",
  footContact: "Kontakt",
  rights: "Të gjitha të drejtat e rezervuara.",
  devBy: "Zhvilluar nga",
  // Addition beyond the design reference: shown only if a real submit request fails.
  formError: "Diçka shkoi keq — provo përsëri ose na shkruaj direkt.",
  programs: [
    {
      title: "Trajnim për meshkuj",
      meta: "3 seanca / javë",
      price: "40 €",
      copy: "Teknikë, kondicion dhe sparring i kontrolluar. Grup i përzier nga fillestarë deri te garues.",
      f1: "Teknika bazë dhe kombinime",
      f2: "Kondicion dhe forcë",
      f3: "Sparring i mbikëqyrur",
    },
    {
      title: "Trajnim për femra",
      meta: "3 seanca / javë",
      price: "35 €",
      copy: "Grup vetëm për femra: teknikë kickbox-i, forcë dhe kondicion në atmosferë mbështetëse.",
      f1: "Grup vetëm për femra",
      f2: "Teknikë dhe vetëmbrojtje",
      f3: "Kardio dhe tonifikim",
    },
    {
      title: "Trajnim për fëmijë",
      meta: "3 seanca / javë · mosha 6–14",
      price: "30 €",
      copy: "Disiplinë, koordinim dhe vetëbesim përmes lojës dhe teknikës bazë.",
      f1: "Disiplinë dhe respekt",
      f2: "Koordinim përmes lojës",
      f3: "Grupe sipas moshës",
    },
    {
      title: "Trajnim individual",
      meta: "Sipas marrëveshjes",
      price: "250 €",
      copy: "Seanca 1-me-1 me trajnerin, plan i personalizuar dhe përgatitje për gara.",
      f1: "Plan i personalizuar",
      f2: "Përgatitje për gara",
      f3: "Orar fleksibil",
    },
  ],
  days: ["E hënë", "E mërkurë", "E premte"],
  schedule: [
    ["Fëmijë", ["18:00 – 19:00", "18:00 – 19:00", "18:00 – 19:00"]],
    ["Femra", ["18:00 – 19:00", "18:00 – 19:00", "18:00 – 19:00"]],
    ["Meshkuj", ["18:00 – 19:00", "18:00 – 19:00", "18:00 – 19:00"]],
  ],
  timeline: [
    [
      "1996",
      "Vushtrri",
      "Klubi i parë Team Menxhiqi, themeluar nga pionierët e sportit në Kosovë. Aktiv edhe sot.",
    ],
    [
      "2000",
      "Goes, Holandë",
      "Pika e dytë — bashkëpunime ndërkombëtare dhe zhvillim i sportistëve në diasporë.",
    ],
    [
      "2016",
      "Stanofc, Vushtrri",
      "Pika e tretë, e hapur për të rinjtë me potencial në sportet luftarake.",
    ],
    [
      "2023",
      "Prishtinë",
      "CFC Team Menxhiqi — pika më e re, që kompleton rrjetin e klubeve.",
    ],
  ],
  champions: [
    ["Tahir Menxhiqi", "Kampion bote WKA · K-1 World Max"],
    ["Ilir Canolli", "Ar në Thai-Box (90 kg), Botërori i Berlinit"],
    ["Ilir Menxhiqi", "Ar në Thai-Box & Kick-Box (60 kg), 2010"],
    ["Dardan Menxhiqi", "Kampion bote · sportist i dalluar i Vushtrrisë"],
  ],
};

export const EN = {
  navPrograms: "Programs",
  navSchedule: "Schedule",
  navHistory: "History",
  navContact: "Contact",
  navCta: "Free trial",
  scroll: "Scroll",
  heroKicker: "Kickboxing club · Prishtina · since 1996",
  heroLine1: "Kickbox.",
  heroLine2: "The way champions do.",
  heroSub:
    "Training for men, women and kids from the most successful club in Kosovo. World champions, 29 years of experience, one gym in Prishtina — the place that trains tomorrow's champions.",
  heroCta: "Book your free first session",
  heroCta2: "See the schedule",
  wc: "World champion",
  since: "since",
  s1: "Years of coaching",
  s2: "World champions",
  s3: "Clubs in Kosovo & the Netherlands",
  s4: "Sessions per week",
  progKicker: "Programs & pricing",
  progTitle: "A program for every level.",
  progIntro:
    "Groups split by age and level. Beginners are welcome — we provide the gear for your first session.",
  progCta: "Sign up",
  perMonth: "/ month",
  popular: "Most popular",
  progNote: "The first session is free on every program. No sign-up fee.",
  schedKicker: "Schedule",
  schedTitle: "When we train.",
  schedGroup: "Group",
  schedNote: "Times may shift around holidays and competitions — follow Instagram for updates.",
  histKicker: "History",
  histTitle: "Thirty years in the ring.",
  histIntro:
    "Team Menxhiqi was founded by the pioneers of kickboxing in Kosovo. Named the most successful club in the country for years running, it has supplied the Kosovo national team with fighters for decades.",
  champTitle: "World champions from the club",
  coachKicker: "Head coach",
  coachBadge: "Kosovo national coach",
  coachTitle: "Ilir Menxhiqi — champion and coach",
  coachP1:
    "One of the best-known figures in Kosovar kickboxing. At the 2010 World Championships he took gold in both Thai-Box and Kick-Box at 60 kg, and was named Vushtrri athlete of the year.",
  coachP2:
    "As a coach he leads the Kosovo national kickboxing team as selector and was named coach of the year for 2024. Today he trains the next generation at CFC Prishtina.",
  cf1: "Gold at 2010 Worlds — Thai-Box & Kick-Box",
  cf2: "Athlete of the year, Vushtrri",
  cf3: "Coach of the year",
  contactKicker: "Contact",
  contactTitle: "Find us in Prishtina.",
  addrLabel: "Address",
  phoneLabel: "Phone & email",
  formTitle: "Book your first session — free",
  formSub: "We'll get back to you within 24 hours to set a day.",
  fName: "First name",
  fSurname: "Last name",
  fEmail: "Email",
  fProgram: "Program",
  fMessage: "Message (optional)",
  submit: "Send request",
  submitted: "Request sent — we'll be in touch shortly",
  closeTitle: "The first session is free. Come to the gym.",
  closeCta: "Book now",
  footTag: "Kickboxing club in Prishtina, part of the Team Menxhiqi network since 1996.",
  footInfo: "Info",
  footSocial: "Social",
  footContact: "Contact",
  rights: "All rights reserved.",
  devBy: "Developed by",
  // Addition beyond the design reference: shown only if a real submit request fails.
  formError: "Something went wrong — please try again or write to us directly.",
  programs: [
    {
      title: "Men's training",
      meta: "3 sessions / week",
      price: "40 €",
      copy: "Technique, conditioning and controlled sparring. Mixed group from beginners to competitors.",
      f1: "Fundamentals and combinations",
      f2: "Conditioning and strength",
      f3: "Supervised sparring",
    },
    {
      title: "Women's training",
      meta: "3 sessions / week",
      price: "35 €",
      copy: "Women-only group: kickboxing technique, strength and conditioning in a supportive setting.",
      f1: "Women-only group",
      f2: "Technique and self-defence",
      f3: "Cardio and toning",
    },
    {
      title: "Kids' training",
      meta: "3 sessions / week · ages 6–14",
      price: "30 €",
      copy: "Discipline, coordination and confidence through play and fundamentals.",
      f1: "Discipline and respect",
      f2: "Coordination through play",
      f3: "Age-based groups",
    },
    {
      title: "Individual training",
      meta: "By arrangement",
      price: "250 €",
      copy: "1-on-1 sessions with the coach, a personal plan and competition prep.",
      f1: "Personal plan",
      f2: "Competition prep",
      f3: "Flexible schedule",
    },
  ],
  days: ["Monday", "Wednesday", "Friday"],
  schedule: [
    ["Kids", ["18:00 – 19:00", "18:00 – 19:00", "18:00 – 19:00"]],
    ["Women", ["18:00 – 19:00", "18:00 – 19:00", "18:00 – 19:00"]],
    ["Men", ["18:00 – 19:00", "18:00 – 19:00", "18:00 – 19:00"]],
  ],
  timeline: [
    [
      "1996",
      "Vushtrri",
      "The first Team Menxhiqi club, founded by the pioneers of the sport in Kosovo. Still active today.",
    ],
    [
      "2000",
      "Goes, Netherlands",
      "The second location — international partnerships and athletes in the diaspora.",
    ],
    [
      "2016",
      "Stanofc, Vushtrri",
      "The third location, opened for young talent in combat sports.",
    ],
    [
      "2023",
      "Prishtina",
      "CFC Team Menxhiqi — the newest location, completing the club network.",
    ],
  ],
  champions: [
    ["Tahir Menxhiqi", "WKA world champion · K-1 World Max"],
    ["Ilir Canolli", "Thai-Box gold (90 kg), Berlin Worlds"],
    ["Ilir Menxhiqi", "Thai-Box & Kick-Box gold (60 kg), 2010"],
    ["Dardan Menxhiqi", "World champion · Vushtrri distinguished athlete"],
  ],
};

// [value, suffix] — verbatim from the design reference's STATS constant.
export const STATS = [
  [29, ""],
  [4, ""],
  [4, ""],
  [10, "+"],
];
